import React, { useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import showAlert from "utils/showAlert";
import CustomTooltip from "utils/CustomTooltip";

export default function ChartHelpModal(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const hideModal = () => setIsModalVisible(false);

  let tooltipMessage = "";
  if (props.title == "Marketing Spend Funnel Allocation") {
    tooltipMessage = "This chart shows the allocation of your marketing spend across the different stages of the marketing funnel. Click this tooltip to see how the data is organized.";
  } else if (props.title == "Prospecting vs Remarketing L60D") {
    tooltipMessage = "This chart shows your paid social prospecting spend compared to remarketing. Click this tooltip to see how the data is organized.";
  } else if (props.title == "Branded vs. Non-Branded L60D") {
    tooltipMessage = "This chart shows your paid search branded spend compared to non-branded. Click this tooltip to see how the data is organized.";
  }

  const modalBodyText = () => {
    if (props.title == "Marketing Spend Funnel Allocation") {
      return (
        <>
          <p className="mb-2"><b>This chart organizes your marketing campaigns based on their names. If some campaigns show as 'Uncategorized,' you might need to adjust their names to match the filters below:</b></p>
          <p><b>(Campaign names are not case-sensitive)</b></p>
          
          <h5 className="my-2">Top of Funnel:</h5>
          <ul>
            <li>Any campaign with 'prospecting' in the name</li>
            <li>All Google Ads display, discovery, and demand gen campaigns</li>
          </ul>
          
          <h5 className="my-2">Mid Funnel:</h5>
          <ul>
            <li>Google and Microsoft Ads search and shopping campaigns that do not include 'branded'</li>
            <li>Google Ads performance max campaigns that do not include 'branded'</li>
          </ul>
          
          <h5 className="my-2">Lower Funnel:</h5>
          <ul>
            <li>Google and Microsoft Ads search, shopping, and performance max campaigns that include 'branded'</li>
            <li>Google Ads display, discovery, and video (YouTube) campaigns that include 'remarketing' or 'branded'</li>
            <li>Meta, TikTok, and Pinterest Ads campaigns that include 'remarketing'</li>
          </ul>
          
          <p className="mt-2">Campaigns that don't match these filters will be marked as 'Uncategorized'.</p>
        </>
      );

    } else if (props.title == "Prospecting vs Remarketing L60D") {
      return (
        <>
         <p className="mb-2"><b>This chart shows your prospecting spend compared to remarketing for Paid Social platforms. Data will be tracked here if the campaigns match the filters below:</b></p>
          <p><b>(Campaign names are not case-sensitive)</b></p>
          
          <h5 className="my-2">Prospecting:</h5>
          <ul>
            <li>Meta Ads, TikTok Ads, Pinterest Ads & YouTube campaigns that include 'prospecting' in the title</li>
            <li>Google Ads display & demand gen campaigns that include 'prospecting' in the title</li>
          </ul>

          <h5 className="my-2">Remarketing:</h5>
          <ul>
            <li>Meta Ads, TikTok Ads, Pinterest Ads & YouTube campaigns that include 'remarketing' in the title</li>
            <li>Google Ads display & demand gen campaigns that include 'remarketing' in the title</li>
          </ul>
        </>
      );

    } else if (props.title == "Branded vs. Non-Branded L60D") {
      return (
        <>
          <p className="mb-2"><b>This chart shows your branded spend compared to non-branded for Paid Search platforms. Data will be tracked here if the campaigns match the filters below:</b></p>
          <p><b>(Campaign names are not case-sensitive)</b></p>

          <h5 className="my-2">Branded:</h5>
          <ul>
            <li>Google and Microsoft Ads search, shopping, and performance max campaigns that include 'branded' in the title</li>
          </ul>

          <h5 className="my-2">Non-Branded:</h5>
          <ul>
            <li>Google and Microsoft Ads search, shopping, and performance max campaigns that do not include 'branded' in the title</li>
          </ul>
        </>
      );
    }
  }

  return (
    <>
      <div style={{cursor: "pointer"}} onClick={() => setIsModalVisible(true)}>
        <CustomTooltip 
          faClass="far fa-question-circle f18 pl-2 chart-help-icon" 
          message={tooltipMessage} 
          inline={true} 
        />
      </div>

      <Modal show={isModalVisible} onHide={hideModal} className="chart-help-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>{props.title}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4 chart-help-modal-inner">
            {modalBodyText()}
          </div>

          <div className="chart-help-modal-buttons">
            <button type="button" className="button b-type-primary b-size-normal b-color-green api-access-button" onClick={hideModal}>
              Got it!
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}